import React from 'react';
import { Shield } from 'lucide-react';

export const HipaaTab = ({ hipaaConsent, loadingHipaa }) => (
  <>
    {
    loadingHipaa ? (
      <div className="text-center py-8"><div className="w-8 h-8 border-4 border-rose-500 border-t-transparent rounded-full animate-spin mx-auto" /><p className="mt-3 text-gray-500 text-sm">Loading HIPAA consent...</p></div>
    ) : hipaaConsent ? (
      <div className="space-y-4" data-testid="hipaa-signed-form">
        <div className="bg-green-50 border border-green-200 rounded-lg p-3 flex items-center gap-2">
          <Shield className="h-5 w-5 text-green-600 flex-shrink-0" />
          <div>
            <p className="text-green-800 font-medium text-sm">HIPAA Authorization Signed</p>
            <p className="text-green-600 text-xs">Signed on {new Date(hipaaConsent.signedAt).toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })}</p>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
          <div className="bg-slate-700 px-5 py-3 text-center">
            <p className="text-white font-bold text-sm">HIPAA Authorization for Electronic Access to Health Information</p>
          </div>
          <div className="p-5 space-y-4">
            <div className="grid grid-cols-2 gap-4 bg-gray-50 rounded-lg p-3 border border-gray-100 text-sm">
              <div><p className="text-gray-400 text-xs uppercase tracking-wide mb-0.5">Practice</p><p className="font-semibold text-gray-900">{hipaaConsent.practiceName}</p></div>
              <div><p className="text-gray-400 text-xs uppercase tracking-wide mb-0.5">Patient</p><p className="font-semibold text-gray-900">{hipaaConsent.patientName}</p></div>
            </div>
            <div className="space-y-2">
              {(hipaaConsent.formContent?.sections || []).map((text, i) => (
                <div key={i} className="flex gap-2">
                  <span className="text-blue-600 font-bold text-xs mt-0.5 flex-shrink-0">{i+1}.</span>
                  <p className="text-gray-700 text-xs leading-relaxed">{text}</p>
                </div>
              ))}
            </div>
            <div className="border-t border-gray-200 pt-4">
              <p className="text-gray-400 text-xs uppercase tracking-wide mb-2">Signature ({hipaaConsent.signatureType === 'draw' ? 'Drawn' : 'Typed'})</p>
              {hipaaConsent.signatureType === 'draw' ? (
                <img src={hipaaConsent.signatureData} alt="Patient Signature" className="max-h-20 border border-gray-200 rounded bg-white p-1" data-testid="hipaa-signature-image" />
              ) : (
                <p className="text-2xl text-gray-800" style={{ fontFamily: "'Brush Script MT', 'Segoe Script', cursive" }} data-testid="hipaa-typed-sig-display">{hipaaConsent.signatureData}</p>
              )}
              <p className="text-gray-500 text-xs mt-2">Date: {new Date(hipaaConsent.signedAt).toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })}</p>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div className="text-center py-8 text-gray-500">
        <Shield className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <p>No HIPAA authorization on file</p>
        <p className="text-sm text-gray-400 mt-1">Patient will be asked to sign when they first access their portal</p>
      </div>
    )
    }
  </>
);
